export default (palette) => ({
  primary: {
    fontWeight: 600, // Padronização de peso solicitada pelo usuário 📐🧼
    fontSize: '0.875rem',
    color: palette.text.primary, // Reativo ao tema!
  }
})
